module.exports = __webpack_public_path__ + "static/media/ecommerce-Technologies400x250.52b8b563.jpg";